"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var defaults_1 = __importDefault(require("../defaults"));

var dimensions_1 = __importStar(require("../dimensions"));

var PlateCalc =
/** @class */
function () {
  function PlateCalc(plateBuilder) {
    var _this = this; // Sooo... interestingly enough, this seems to really only be used for cut-outs... it was used for aprons but I took it out
    // Also being used for apron... I should break it out into its own function for apron actually... since we dont use most of this
    // Apron literally just needs to know space on left of first trough, and space on right of last trough


    this.spacePositions = function (forElement, elements, centralPositions) {
      if (centralPositions === void 0) {
        centralPositions = true;
      }

      var requiredWidth = forElement && forElement.outerWidth || 0;
      var troughElementTypes = ['trough', 'tap', 'soap-dispenser'];
      var spaceWrapperElementTypes = ['wall', 'edge'].concat(troughElementTypes);
      var spacePositions = [];
      var preparedBackWallWith = _this.trough.preparedBackWallWith;

      if (!elements) {
        // TODO - This could cause infinite recursion in the future... its not right now though so ehhh
        // Cant remember why we populate without any cutouts... hmm
        // Good place to add some special rules though, like disabling extendOverhangs and consoles, since these can mess up the calculations for cut-outs
        var simulatedWashbasin = _this.plateBuilder.populateWithConfOverrides({
          builtInParts: {
            cutOutDisposals: false,
            cutOutDisposalsPosition: null,
            paperTowelDispensers: false,
            paperTowelDispensersPosition: null,
            tissueDispenser: false,
            tissueDispenserPosition: null
          }
        }, {
          disableExtendOverhangs: true,
          disableConsoles: preparedBackWallWith
        });

        elements = simulatedWashbasin.elements.concat(simulatedWashbasin.additional);
      } // console.log('simulated...', elements);
      // elements = elements.filter((e) => (e.type !== 'spacer')); //  && e.type !== 'safety-catch'


      if (!elements) {
        return spacePositions;
      }

      elements.forEach(function (element, index) {
        var isSpaceWrapper = spaceWrapperElementTypes.includes(element.type);

        if (!isSpaceWrapper) {
          return;
        }

        var nextElements = elements && elements.slice(index + 1, elements.length);
        var nextSpaceWrapper = nextElements && nextElements.filter(function (e) {
          return spaceWrapperElementTypes.includes(e.type);
        })[0];

        if (!nextSpaceWrapper || element.troughIndex === nextSpaceWrapper.troughIndex) {
          return;
        } // Ahhh... it's omitting element if it's the same troughIndex!


        var isTroughToTrough = troughElementTypes && troughElementTypes.includes(nextSpaceWrapper.type) && troughElementTypes.includes(element.type); // Space between elements...

        var spaceFrom = element.sides.right;
        var spaceTo = nextSpaceWrapper.sides.left;
        var spaceDiff = spaceTo - spaceFrom;

        if (isTroughToTrough) {
          var dummyConsole = _this.elementsBuilder.buildConsole({
            hidden: true
          });

          var troughDistances = _this.conf.washBasinDimension && _this.conf.washBasinDimension.distances; // console.log('isTroughToTrough', element.type);

          var segmentCount = 4;
          var segmentSize = spaceDiff / segmentCount;

          if (centralPositions) {
            for (var i = 1; i < 4; i++) {
              spacePositions.push(spaceFrom + segmentSize * i);
            }
          } else {
            for (var i = 1; i < 4; i++) {
              if (i === 1) {
                // Exactly same as below for first/last console, but not sure how to refactor
                var troughPosition = troughDistances && element.troughIndex ? troughDistances[element.troughIndex] : element.position.x;
                var position = troughPosition + element.scale.x / 2 + element.buffer.right;
                position = position + requiredWidth / 2;

                if (!_this.trough.preparedBackWallWith) {
                  position = position + dummyConsole.scale.x;
                } else {
                  position = position + dimensions_1.default.techSpecs.freeOverhang.cutOutWithBackwall.min;
                }

                spacePositions.push(position);
              }

              if (i === 2) {
                spacePositions.push(spaceFrom + segmentSize * i);
              }

              if (i === 3) {
                var position = nextSpaceWrapper.position.x - nextSpaceWrapper.scale.x / 2 - nextSpaceWrapper.buffer.left;
                position = position - requiredWidth / 2;

                if (!_this.trough.preparedBackWallWith) {
                  position = position - dummyConsole.scale.x;
                } else {
                  position = position - dimensions_1.default.techSpecs.freeOverhang.cutOutWithBackwall.min;
                }

                spacePositions.push(position);
              }
            }
          }
        } else {
          // console.log('distances... ', requiredWidth);
          // console.log('spacediff', spaceFrom, spaceDiff);
          // If we don't have any width, then we get the middle position of the first/last space... is this correct?
          // I can't remember why we dont just always pass in the requiredWidth... ahhh, it's to calculate the max space available, so maybe I can move that into something else? Why else would I need to use it...
          // maxSpaceSizes function, or something like that... then things become a bit less confusing, and I can probably re-use stuff here more easily
          // I guess its easier to leave it as is for now but hmm... how would maxSpaceSize work when I'm not using percentage positions... I guess it would actually go from the center every time
          if (centralPositions) {
            if (elements && (!forElement || forElement.type === 'cut-out')) {
              // const prevElements: PlateElement[] = elements && elements.slice(0, index).reverse() || [];
              // const prevFixedElement = prevElements.find(e => e.isFixed);
              // const nextFixedElement = nextElements && nextElements.find(e => e.isFixed);
              // console.log('spaceFrom', spaceFrom);
              // console.log('spaceTo', spaceTo);
              // 
              var spaceCenter = spaceFrom + spaceDiff / 2; // console.log('spaceCenter', spaceCenter);
              // Almost a direct copy to spaceSizings below... 

              var consolesToLeft = _this.consolesWithinPositions(elements, spaceFrom, spaceCenter - 1).reverse();

              var consolesToRight = _this.consolesWithinPositions(elements, spaceCenter, spaceTo); // const isFirstPosition = consolesToLeft.find(e => e.isFirst);
              // const isLastPosition = consolesToRight.find(e => e.isLast);


              var consolesToLeftWidth = consolesToLeft.reduce(function (accumulator, el) {
                return accumulator + el.outerWidth;
              }, 0);
              var consolesToRightWidth = consolesToRight.reduce(function (accumulator, el) {
                return accumulator + el.outerWidth;
              }, 0); // console.log('left', consolesToLeft, 'right', consolesToRight);

              if (forElement && forElement.type === 'cut-out') {
                // && !this.trough.preparedBackWallWith) { // I think prepared backwall adds consoles too? so why exclude...
                if (consolesToLeft.length === 0) {
                  var dummyConsole = _this.elementsBuilder.buildConsole({
                    isFirst: spacePositions.length === 0,
                    hidden: true
                  });

                  consolesToLeftWidth = consolesToLeftWidth + dummyConsole.scale.x;
                }

                if (consolesToRight.length === 0) {
                  var dummyConsole = _this.elementsBuilder.buildConsole({
                    isLast: spacePositions.length > 0,
                    hidden: true
                  }); // I know its edge because trough to trough is done above


                  consolesToRightWidth = consolesToRightWidth + dummyConsole.scale.x;
                } // Was adding buffer here, but consoles already have buffer so hmm... the problem is prepared backwall troughs...
                // If consolesToRight/Left is 0, I need to figure out if this is the first/last spacePosition and if so then add buffer to imagenary console... maybe halve it after for spaceSizings because it gets doubled up

              } // const firstFixedToLeft = consolesToLeft.find(e => e.isFixed); // Was looking at safety-catch which is stretched over
              // const firstFixedToRight = consolesToRight.find(e => e.isFixed);


              var startLeft = spaceFrom + consolesToLeftWidth;
              var startRight = spaceTo - consolesToRightWidth;
              var positionDiff = startRight - startLeft;
              var positionCenter = startLeft + positionDiff / 2; // console.log('startLeft', startLeft);
              // console.log('startRight', startRight);

              spacePositions.push(positionCenter);
            } else {
              var spaceCenter = spaceFrom + spaceDiff / 2;
              spacePositions.push(spaceCenter);
            }
          } else {
            var dummyConsole = _this.elementsBuilder.buildConsole({
              hidden: true
            });

            var troughDistances = _this.conf.washBasinDimension && _this.conf.washBasinDimension.distances;

            if (element.isFirst && !troughElementTypes.includes(element.type)) {
              var position = nextSpaceWrapper.position.x - nextSpaceWrapper.scale.x / 2 - nextSpaceWrapper.buffer.left;
              position = position - requiredWidth / 2;

              if (!_this.trough.preparedBackWallWith) {
                position = position - dummyConsole.scale.x;
              } else {
                position = position - dimensions_1.default.techSpecs.freeOverhang.cutOutWithBackwall.min;
              }

              spacePositions.push(position);
            } // It's not limiting itself to taps/soap-dispensers to left/right of trough?


            if (element.isLast && troughElementTypes.includes(element.type)) {
              var troughPosition = troughDistances && element.troughIndex ? troughDistances[element.troughIndex] : element.position.x;
              var position = troughPosition + element.scale.x / 2 + element.buffer.right;
              position = position + requiredWidth / 2;

              if (!_this.trough.preparedBackWallWith) {
                position = position + dummyConsole.scale.x;
              } else {
                position = position + dimensions_1.default.techSpecs.freeOverhang.cutOutWithBackwall.min;
              }

              spacePositions.push(position);
            }
          }
        }
      });
      return spacePositions;
    }; // Used for... apronSpaceAvailable (mr-propper), and cutouts, and what else?
    // This can be used for taps/cutouts/other things... purpose is to figure out how much space is available at certain positions in the trough


    this.spaceSizes = function (forElement, spacePositions, elements) {
      // console.log('spaceSizes', forElement);
      var spaceSpotSizes = [];
      spacePositions = spacePositions || _this.spacePositions(forElement);
      elements = elements || _this.plateBuilder.components.elements.concat(_this.plateBuilder.components.additional);

      if (!spacePositions || !elements) {
        return spaceSpotSizes;
      } // console.log('spacePositionsSSSS', spacePositions);
      // console.log('forElement', forElement);


      var hasConsoles = _this.conf.assemblyAccessories && _this.conf.assemblyAccessories.selection;
      var troughs = elements.find(function (e) {
        return e.type === 'trough';
      });
      spacePositions.forEach(function (position, index) {
        if (!elements) {
          return;
        } // console.log('position', position, index);


        var isFirstPosition = index === 0;
        var isLastPosition = spacePositions && index === spacePositions.length - 1;
        var sizing = 0;
        var leftElement;
        var rightElement;

        for (var i = 0; i < elements.length; i++) {
          var element = elements[i];
          var ignorableElements = ['console', 'angle-bar', 'apron', 'surge-edge', 'corner-radius', 'sticker', 'back-splash', 'safety-catch', 'spacer', 'gelcoat']; // Tissue dispenser (different from cut-out provider/paper towel), can be with cut-out that disposes tissues, so we ignore them

          if (forElement) {
            // const isCutout = (forElement.type === 'cut-out');
            // if (isCutout) {
            //   ignorableElements = ignorableElements.filter(e => e !== 'apron');
            // }
            var isTissueDispenser = forElement.type === 'cut-out' && forElement.subType === 'tissue-dispenser';

            if (isTissueDispenser) {
              ignorableElements = ignorableElements.filter(function (e) {
                return e !== 'spacer';
              });
            }

            var isTissueWithDisposal = forElement.type === 'cut-out' && forElement.subType === 'tissue-dispenser' && element.type === 'cut-out' && element.subType === 'disposal';

            if (isTissueWithDisposal) {
              continue;
            }

            var isDisposalWithTissue = forElement.type === 'cut-out' && forElement.subType === 'disposal' && element.type === 'cut-out' && element.subType === 'tissue-dispenser';

            if (isDisposalWithTissue) {
              continue;
            }

            var isConsoleWithBackwall = forElement.type === 'cut-out' && _this.trough.preparedBackWallWith && element.type === 'console';

            if (isConsoleWithBackwall) {
              continue;
            }
          } // console.log(ignorableElements);


          if (ignorableElements.includes(element.type)) {
            continue;
          } // Skip some elements which have no impact on space available


          if (element.type === 'apron' && element.subType === 'width') {
            continue;
          } // Skip some elements which have no impact on space available
          // If another element is already taking up the spot, then we can say 0... 


          var isMatchingType = forElement && forElement.type === element.type && forElement.subType === element.subType; // We can only have 1 type in 1 spot right? so 

          var isMatchingPosition = index === element.positionIndex;
          var isSelfElement = isMatchingType && isMatchingPosition;

          if (isSelfElement) {
            continue;
          } // Skip the element if it is itself... since we don't want to calculate size based on it's current existence
          // What about paper towels though? If I skip, then I am basically saying pretend the paper towel provider is not there, which is wrong...
          // What I need to do is return 0 if we getting cut-out and paper towel is first/last... 


          var isPositionOverlapped = element.outerSides.left < position && element.outerSides.right > position; // console.log('isPositionOverlapped');
          // console.log(element);
          // console.log(isPositionOverlapped);
          // console.log(isSameElementType);

          if (isPositionOverlapped && element.type !== 'console') {
            sizing = 0;
            leftElement = null;
            rightElement = null;
            break;
          } // Get the element to left of position


          if (element.outerSides.right <= position && (!leftElement || element.outerSides.right > leftElement.outerSides.right)) {
            leftElement = element;
          } // Get the element to right of position


          if (element.outerSides.left >= position && (!rightElement || element.outerSides.left < rightElement.outerSides.left)) {
            rightElement = element;
          }
        }

        if (leftElement && rightElement) {
          // if (this.trough.preparedBackWallWith && forElement && forElement.type === 'cut-out') { // Actually, even with preparedBackwall there is a console before/after the cutout... cant remember why I added this, maybe calcs for max custom cutout were wrong
          //   sizing = rightElement.outerSides.left - leftElement.outerSides.right;
          // } else {
          // console.log(JSON.parse(JSON.stringify(leftElement)), JSON.parse(JSON.stringify(rightElement)));
          var consolesToLeft = _this.consolesWithinPositions(elements, leftElement.sides.right, position - 1);

          var consolesToRight = _this.consolesWithinPositions(elements, position, rightElement.sides.left);

          var consolesToLeftWidth = consolesToLeft.reduce(function (accumulator, el) {
            return accumulator + (!el.hidden && el.outerWidth || 0);
          }, 0);
          var consolesToRightWidth = consolesToRight.reduce(function (accumulator, el) {
            return accumulator + (!el.hidden && el.outerWidth || 0);
          }, 0); // console.log('consolesToLeftWidth1', consolesToLeftWidth);
          // console.log('consolesToRightWidth1', consolesToRightWidth);
          // Reducing the console width even though its already been reduced?
          // I have to consider the safety catch when doubling up, ughhh
          // Why not double up the space and include safety catch... like sure maybe it prevents maximum size for the custom cut-outs, but so what?
          // Consoles may not always exist, but non-prepared backwall cut-outs must have a console, so we add

          if (forElement && forElement.type === 'cut-out') {
            // && !this.trough.preparedBackWallWith) { // I think prepared backwall adds consoles too? so why exclude...
            var isMiranit = (!_this.conf.assemblyAccessories || _this.conf.assemblyAccessories.console === null) && _this.conf.defaults.assemblyAccessories.console.default === 'miranit' || _this.conf.assemblyAccessories && _this.conf.assemblyAccessories.console === 'miranit'; // console.log('isMiranit', isMiranit);

            if (_this.trough.preparedBackWallWith && isMiranit) {
              // miranit is a tricky one... because max overhang for cut-out is 100, but miranit is 170... so has to calculate the space based on the overhang for the cut-out
              var leftSpace_1 = position - leftElement.outerSides.right - forElement.scale.x / 2 - forElement.buffer.left;
              var rightSpace_1 = rightElement.outerSides.left - position - forElement.scale.x / 2 - forElement.buffer.right;
              var cutOutOverhang = dimensions_1.default.techSpecs.freeOverhang.cutOut.max;
              var backwallNeedsConsoleLeft = leftSpace_1 > cutOutOverhang;
              var backwallNeedsConsoleRight = rightSpace_1 > cutOutOverhang; // console.log('hmm', index, forElement, leftSpace, rightSpace);
              // console.log('leftSpace', position, leftElement.outerSides.right, (forElement.scale.x / 2), forElement.buffer.left);
              // if space to left is greater than 100mm, preparedBackwall also needs console, otherwise no console required...
              // howeverrrr, the regular checks are probably fine with regular non-miranit consoles right? I think so

              var dummyConsole = _this.elementsBuilder.buildConsole(); // console.log('dummyConsole', dummyConsole.scale.x, leftSpace, cutOutOverhang);


              if (consolesToLeftWidth === 0) {
                if (backwallNeedsConsoleLeft) {
                  consolesToLeftWidth = consolesToLeftWidth + dummyConsole.scale.x;
                } else {
                  consolesToLeftWidth = consolesToLeftWidth + 40; // Spec says there must still be 40mm... I dont know what thats for, but yeah...
                }
              }

              if (consolesToRightWidth === 0) {
                if (backwallNeedsConsoleRight) {
                  consolesToRightWidth = consolesToRightWidth + dummyConsole.scale.x;
                } else {
                  consolesToRightWidth = consolesToRightWidth + 40;
                }
              } // need to test this more... first last, inbetween consoles... compare spec sheet on cut-out to cut-out too

            } else {
              // const hasConsoles = this.conf.assemblyAccessories && this.conf.assemblyAccessories.selection || this.conf.defaults.assemblyAccessories.selection || true;
              var dummyConsole = _this.elementsBuilder.buildConsole(); // {hidden: !hasConsoles}


              if (consolesToLeft.length === 0) {
                consolesToLeftWidth = consolesToLeftWidth + dummyConsole.scale.x;
              }

              if (consolesToRight.length === 0) {
                consolesToRightWidth = consolesToRightWidth + dummyConsole.scale.x;
              } // Must include edge buffer...


              var hasSpacerFirst = consolesToLeft.find(function (e) {
                return e.type === 'spacer';
              });
              var hasAnglebarFirst = consolesToLeft.find(function (e) {
                return e.type === 'angle-bar';
              });

              if (isFirstPosition && !hasSpacerFirst && !hasAnglebarFirst) {
                // Halving the buffer, because further down we multiply the smallest space by 2...
                consolesToLeftWidth = consolesToLeftWidth + dimensions_1.default.techSpecs.freeOverhang.atEdgeLastConsole.min / 2; // consolesToLeftWidth + consolesToLeft.filter((c) => c.isFirst).length * dimensions.techSpecs.freeOverhang.atEdgeLastConsole.min;
              }

              var hasSpacerLast = consolesToRight.find(function (e) {
                return e.type === 'spacer';
              });
              var hasAnglebarLast = consolesToRight.find(function (e) {
                return e.type === 'angle-bar';
              });

              if (isLastPosition && !hasSpacerLast && !hasAnglebarLast) {
                consolesToRightWidth = consolesToRightWidth + dimensions_1.default.techSpecs.freeOverhang.atEdgeLastConsole.min / 2;
              }
            }
          } // console.log('consolesToLeftWidth2', consolesToLeftWidth, leftElement);
          // console.log('consolesToRightWidth2', consolesToRightWidth);


          var leftSpace = position - leftElement.outerSides.right - consolesToLeftWidth;
          var rightSpace = rightElement.outerSides.left - position - consolesToRightWidth; // console.log('leftSpace', leftSpace, position, leftElement.outerSides.right, consolesToLeftWidth);
          // const leftIsSmallest = rightSpace > leftSpace;

          if (forElement && forElement.type === 'cut-out') {
            var smallestSpace = rightSpace < leftSpace ? rightSpace : leftSpace;
            sizing = smallestSpace * 2; // leftSpace + rightSpace;
          } else {
            sizing = leftSpace + rightSpace;
          } // console.log('position', position);
          // console.log('left', leftSpace);
          // console.log('right', rightSpace);
          // }

        }

        spaceSpotSizes.push(sizing);
      }); // console.log('spaceSpotSizes', spaceSpotSizes);

      return spaceSpotSizes;
    };

    this.spaceAroundElement = function (forElement, elements, ignoreTypes, ignoreElement) {
      if (ignoreTypes === void 0) {
        ignoreTypes = ['angle-bar', 'console', 'spacer', 'safety-catch'];
      }

      elements = elements || _this.plateBuilder.components.elements.concat(_this.plateBuilder.components.additional);
      var spaceAround = {
        left: 0,
        right: 0
      };
      elements.forEach(function (element, index) {
        var isMatchingType = forElement && forElement.type === element.type && forElement.subType === element.subType; // We can only have 1 type in 1 spot right? so 

        var isMatchingPosition = element.position.x === forElement.position.x || element.troughIndex === forElement.troughIndex; // TODO - Previously I used a "positionIndex", might be needed

        var isTargetElement = isMatchingType && isMatchingPosition;

        if (isTargetElement) {
          if (!elements) {
            return;
          }

          var prevElements = elements.slice(0, index).reverse() || [];
          var prevActualElements = prevElements.filter(function (e) {
            if (ignoreElement) {
              var isMatchingIgnoreElementType = e.type === ignoreElement.type && e.subType === ignoreElement.subType;
              var isMatchingIgnoreElementPosition = e.position.x === ignoreElement.position.x || e.troughIndex === ignoreElement.troughIndex;
              var isIgnoreElement = isMatchingIgnoreElementType && isMatchingIgnoreElementPosition;

              if (isIgnoreElement) {
                return false;
              }
            }

            if (ignoreTypes.includes(e.type)) {
              return false;
            }

            return true;
          });
          var prevElement = prevActualElements[0];

          var prevConsoleElements = _this.consolesWithinPositions(elements, prevElement.sides.right, element.sides.left);

          var prevConsoleWidth = prevConsoleElements.reduce(function (accumulator, el) {
            return el.type === 'console' && el.buffer.left > 10 ? accumulator + el.scale.x + 10 : accumulator + el.outerWidth;
          }, 0); // console.log('prevConsoleWidth', prevConsoleWidth, forElement.outerSides.left, prevElement.outerSides.right);
          // Get next consoles until trough is found...

          var nextElements = elements.slice(index + 1, elements.length) || [];
          var nextActualElements = nextElements.filter(function (e) {
            if (ignoreElement) {
              var isMatchingIgnoreElementType = e.type === ignoreElement.type && e.subType === ignoreElement.subType;
              var isMatchingIgnoreElementPosition = e.position.x === ignoreElement.position.x || e.troughIndex === ignoreElement.troughIndex;
              var isIgnoreElement = isMatchingIgnoreElementType && isMatchingIgnoreElementPosition;

              if (isIgnoreElement) {
                return false;
              }
            }

            if (ignoreTypes.includes(e.type)) {
              return false;
            }

            return true;
          });
          var nextElement = nextActualElements[0];

          var nextConsoleElements = _this.consolesWithinPositions(elements, element.sides.right, nextElement.sides.left);

          var nextConsoleWidth = nextConsoleElements.reduce(function (accumulator, el) {
            return el.type === 'console' && el.buffer.right > 10 ? accumulator + el.scale.x + 10 : accumulator + el.outerWidth;
          }, 0);

          if (prevElement) {
            spaceAround.left = forElement.outerSides.left - prevElement.outerSides.right - prevConsoleWidth;
          }

          if (nextElement) {
            spaceAround.right = nextElement.outerSides.left - forElement.outerSides.right - nextConsoleWidth;
          }
        }
      });
      return spaceAround;
    };

    this.splitElementsAtTypes = function (types, elements) {
      var split = [];

      for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var element = elements_1[_i];

        if (types.includes(element.type)) {
          break;
        } else {
          split.push(element);
        }
      }

      return split;
    };

    this.getElementsBetweenElements = function (elements, from, to, includeWrappers) {
      if (includeWrappers === void 0) {
        includeWrappers = false;
      }

      var reachedFrom = false;
      var reachedTo = false;
      var inbetweenElements = elements.reduce(function (accu, element) {
        if (JSON.stringify(element) === JSON.stringify(to)) {
          reachedTo = true; // if (includeWrappers) {
          //   accu.push(element);
          // }
        }

        if (reachedFrom && !reachedTo) {
          accu.push(element);
        }

        if (JSON.stringify(element) === JSON.stringify(from)) {
          reachedFrom = true; // if (includeWrappers) {
          //   accu.push(element);
          // }
        }

        return accu;
      }, []);

      if (includeWrappers) {
        inbetweenElements.unshift(from);
        inbetweenElements.push(to);
      }

      return inbetweenElements;
    };

    this.consolesWithinPositions = function (elements, from, to) {
      var consoles = [];
      elements.forEach(function (element, index) {
        if ((element.type === 'console' || element.type === 'safety-catch' || element.type === 'angle-bar' || element.type === 'spacer') && element.position.x >= from && element.position.x <= to) {
          consoles.push(element);
        }
      });
      return consoles;
    };

    this.troughPositionsRange = function () {
      var confOverrides = {
        washBasinDimension: {
          plateWidth: 0,
          distances: null
        }
      };

      var components = _this.plateBuilder.populateWithConfOverrides(confOverrides);

      var troughs = components.elements.filter(function (e) {
        return e.type === 'trough';
      });
      return {
        min: troughs[0].position.x,
        max: _this.plateBuilder.components.plate.scale.x - (components.plate.scale.x - troughs[troughs.length - 1].position.x)
      };
    };

    this.troughInitialPositions = function () {
      var troughs;

      if (_this.conf.washBasinDimension && _this.conf.washBasinDimension.distances) {
        var confOverrides = {
          assemblyAccessories: {
            console: _this.conf.defaults.assemblyAccessories.console.default || defaults_1.default.assemblyAccessories.console.default,
            selection: _this.conf.defaults.assemblyAccessories.selection.default || defaults_1.default.assemblyAccessories.selection.default
          },
          washBasinDimension: {
            distances: null,
            plateWidth: dimensions_1.default.defaultInputs.plateWidth.max
          },
          builtInParts: null
        };

        var components = _this.plateBuilder.populateWithConfOverrides(confOverrides);

        troughs = components.elements.filter(function (e) {
          return e.type === 'trough';
        });
      } else {
        troughs = _this.plateBuilder.components.elements.filter(function (e) {
          return e.type === 'trough';
        });
      }

      var positions = troughs.reduce(function (accumulator, trough) {
        accumulator.push(trough.position.x);
        return accumulator;
      }, []);
      return positions;
    };

    this.troughToTroughWidth = function () {
      var confOverrides = {
        selectedTrough: {
          qty: 2
        },
        washBasinDimension: {
          distances: null
        }
      };

      var components = _this.plateBuilder.populateWithConfOverrides(confOverrides);

      var troughs = components.elements.filter(function (e) {
        return e.type === 'trough';
      });
      return troughs[1].position.x - troughs[0].position.x;
    };

    this.troughToTroughCenters = function () {
      var positionElements = _this.plateBuilder.components.elements.filter(function (e) {
        return e.type === 'trough' || e.type === 'wall' || e.type === 'edge';
      });

      var positions = [];
      positionElements.forEach(function (element, index) {
        var nextElement = positionElements[index + 1];

        if (nextElement) {
          var gap = nextElement.position.x - element.position.x;
          positions.push(gap);
        }
      });
      return positions;
    };

    this.plateMinWidth = function (qty, withTrough) {
      var confOverrides = {
        selectedTrough: {
          qty: qty ? qty : _this.conf.selectedTrough && _this.conf.selectedTrough.qty
        },
        washBasinDimension: {
          plateWidth: null,
          distances: null
        },
        builtInParts: null
      };

      if (withTrough) {
        confOverrides.selectedTrough.trough = withTrough;
      }

      var components = _this.plateBuilder.populateWithConfOverrides(confOverrides);

      var trough = components.elements.find(function (e) {
        return e.type === 'trough';
      }); // console.log('min', components);

      var scales = {
        left: components.plate.scale.x / 2,
        right: components.plate.scale.x / 2,
        total: components.plate.scale.x
      };

      if (trough) {
        scales.left = trough.position.x;
        scales.right = components.plate.scale.x - trough.position.x;
      }

      return scales;
    };

    this.plateWidthRange = function () {
      var min = _this.plateMinWidth().total; // Using the defaults.ts file, not the conf defaults


      return {
        current: _this.plateBuilder.components.plate.scale.x,
        min: min > defaults_1.default.washBasinDimension.plateWidth.values.max ? defaults_1.default.washBasinDimension.plateWidth.values.max : min,
        max: defaults_1.default.washBasinDimension.plateWidth.values.max
      };
    };

    this.plateMinDepth = function () {
      var confOverrides = {
        washBasinDimension: {
          plateDepth: 0
        }
      };

      var components = _this.plateBuilder.populateWithConfOverrides(confOverrides);

      return components.plate.scale.z;
    };

    this.plateDepthRange = function () {
      if (_this.trough.preparedBackWallWith) {
        return {
          current: _this.plateBuilder.components.plate.scale.z,
          min: _this.trough.plateDepth.max,
          max: _this.trough.plateDepth.max
        };
      }

      var min = _this.plateMinDepth();

      return {
        current: _this.plateBuilder.components.plate.scale.z,
        min: min > defaults_1.default.washBasinDimension.plateDepth.values.max ? defaults_1.default.washBasinDimension.plateDepth.values.max : min,
        max: defaults_1.default.washBasinDimension.plateDepth.values.max
      };
    };

    this.recommendationForWallFittings = function () {
      if (!_this.conf.selectedTrough) {
        return 0;
      }

      var trough = _this.conf.selectedTrough.trough;
      var recommendation = trough.distBetween + trough.throughDepth + trough.distRearEdge;
      var recommendationRounded = Math.ceil(recommendation / 10) * 10;
      return recommendationRounded;
    };

    this.recommendationForStandardFittings = function () {
      var recommendation = _this.minDepthForDrillHoleAtBack();

      var recommendationRounded = Math.ceil(recommendation / 10) * 10;
      return recommendationRounded;
    };

    this.minDepthForDrillHoleAtBack = function () {
      if (!_this.conf.selectedTrough || !_this.conf.selectedTrough.trough.distDrillHoleAtBack) {
        return 0;
      }

      var trough = _this.conf.selectedTrough.trough;
      var min = trough.distBetween + trough.distDrillHoleAtBack + dimensions_1.distance.wallAB + trough.throughDepth;
      return min;
    };

    this.isDrillHoleAtBackEnabled = function () {
      if (_this.trough.preparedBackWallWith) {
        return true;
      }

      if (!_this.conf.washBasinDimension || !_this.trough.distDrillHoleAtBack) {
        return false;
      }

      var min = _this.minDepthForDrillHoleAtBack();

      if (!_this.conf.isVariusMed && _this.conf.washBasinDimension.plateDepth >= min) {
        return true;
      }

      return false;
    };

    this.hasOverlappingError = function (elements) {
      var error = false;

      if (!elements) {
        elements = _this.plateBuilder.components.elements;
      }

      elements.forEach(function (element, index) {
        var nextElement = elements[index + 1];

        if (nextElement) {
          var isAnglebar = element.type === 'angle-bar' && nextElement.type === 'wall' || element.type === 'wall' && nextElement.type === 'angle-bar'; // Last angle bar has a strange fix due to model issues, so it overlaps the wall but visually it doesnt

          if (element.outerSides.right > nextElement.outerSides.left && !isAnglebar) {
            console.log('overlap', element, nextElement);
            error = true;
            return;
          }
        }
      });
      return error;
    };

    this.hasConsoleOverlappingError = function (elements) {
      var error = false;

      if (!elements) {
        elements = _this.plateBuilder.components.elements;
      }

      elements.forEach(function (element, index) {
        var nextElement = elements[index + 1];

        if (nextElement && (element.type === 'console' || element.type === 'safety-catch') && (nextElement.type === 'console' || nextElement.type === 'safety-catch')) {
          if (element.outerSides.right > nextElement.outerSides.left && !element.hidden && !nextElement.hidden) {
            // console.log(element, nextElement);
            error = true;
            return;
          }
        }
      });
      return error;
    };

    this.getMaxTroughQty = function (selectedTrough) {
      var qtyLimit = 3; // All troughs can fit with 3

      var hasFoundQtyLimit = false;
      var plateWidthLimit = defaults_1.default.washBasinDimension.plateWidth.values.max;

      while (!hasFoundQtyLimit && qtyLimit < 20) {
        var nextQtyLimit = qtyLimit + 1; // console.log('nextQtyLimit', nextQtyLimit);

        var simulatedPlateWidth = _this.plateMinWidth(nextQtyLimit, selectedTrough);

        if (simulatedPlateWidth.total <= plateWidthLimit) {
          qtyLimit = nextQtyLimit;
        } else {
          hasFoundQtyLimit = true;
        }
      }

      return qtyLimit;
    };

    this.removeElementsByType = function (elements, type) {
      elements = elements.filter(function (element) {
        return element.type !== type;
      });
      return elements;
    };

    this.plateBuilder = plateBuilder;
    this.elementsBuilder = this.plateBuilder.elementsBuilder;
    this.conf = this.plateBuilder.conf;
    this.trough = this.plateBuilder.trough;
  }

  return PlateCalc;
}();

exports.PlateCalc = PlateCalc;
exports.default = PlateCalc;